import { StrictMode } from 'react';

import { AgGridProvider } from 'ag-grid-react';
import { setNonce } from 'get-nonce';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { AppBootstrapGate } from '@app/AppBootstrapGate';
import { AuthBroadcastListener } from '@app/AuthBroadcastListener';
import { appConfig } from '@app/config/appConfig';
import { initializeNewRelic } from '@app/new-relic/newRelicInitializer';
import { routes } from '@app/routes/routes';
import { persistor, store } from '@app/store/store';
import { TooltipProvider } from '@shared/components/ui';
import { AG_GRID_MODULES } from '@shared/components/ui/custom/ag-grid/utils/setup';
import { ThemeProvider } from '@shared/theme/theme-provider';
import { ThemedToaster } from '@shared/theme/theme-toaster';

import 'react-toastify/ReactToastify.css';
import '@shared/theme/global.css';

const router = createBrowserRouter(routes);

const { cspNonce } = appConfig;

if (cspNonce) {
  setNonce(cspNonce);
}

initializeNewRelic();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <TooltipProvider>
            <AgGridProvider modules={AG_GRID_MODULES}>
              <AuthBroadcastListener />
              <AppBootstrapGate>
                <RouterProvider router={router} />
              </AppBootstrapGate>
            </AgGridProvider>
            <ThemedToaster />
          </TooltipProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
);
